import {gql} from '@apollo/client';

export const notificationQueries = {
    Notifications: gql`
        query Notifications(
            $after: String
            $first: Int
            $before: String
            $last: Int
            $where: NotificationModelFilterInput
            $order: [NotificationModelSortInput!]
        ) {
            notifications(after: $after, first: $first, before: $before, last: $last, where: $where, order: $order) {
                totalCount
                edges {
                    cursor
                }
                nodes {
                    id
                    active
                    title
                    userId
                    tenantId
                    status
                    url
                    createdDate
                    tokens
                    user
                    uniqueId
                    order
                    type
                    data
                }
                pageInfo {
                    hasNextPage
                    hasPreviousPage
                    startCursor
                    endCursor
                }
            }
        }
    `,
    UNREAD_NOTIFICATIONS_COUNT: gql`
        query UnreadNotificationsCount($userId: UUID!) {
            notifications(where: {userId: {eq: $userId}, status: {eq: "Unread"}}) {
                totalCount
            }
        }
    `,
};
